import {
  useActionTab,
  useSelectSignalsBroadcastedValue,
  BroadcastInitialValue,
} from '@kinetic-ui/broadcast';
import { SELECT_SIGNALS_ACTION_ROUTE } from '~/router/constants';
import { getActionRoute } from '~/router/getActionRoute';

export const useSelectSignalsAction = (
  options?: BroadcastInitialValue<typeof useSelectSignalsBroadcastedValue>
) => {
  const { openActionTab, actionTabRef } = useActionTab({
    tabRoute: getActionRoute(SELECT_SIGNALS_ACTION_ROUTE),
  });
  const value = useSelectSignalsBroadcastedValue(options);
  return {
    openActionTab,
    actionTabRef,
    value,
  };
};
